/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2022 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {

  // Team cards slider
  const $teamCardsSlider = $('.team-cards-slider__multi-sliders');


  // Check if the slider element exists
  if ($teamCardsSlider.length > 0) {
    // Initialize the slick slider
    $teamCardsSlider.slick({
      slidesToShow: 1,
      infinite: false,
      variableWidth: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1330,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          }
        },
      ],
    });

    // Debounce function to limit how often a function can fire
    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // Resize the slick slider on window resize, debounced
    $(window).on('resize', debounce(() => {
      $teamCardsSlider.slick('resize');
    }, 200));
  }
}(jQuery));